import { render, staticRenderFns } from "./CollectionsLanguage.vue?vue&type=template&id=4a238bff"
import script from "./CollectionsLanguage.vue?vue&type=script&lang=js"
export * from "./CollectionsLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports